/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetProvidersErrorResponse,
  GetProvidersParams,
  GetProvidersResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getProviders = (params?: GetProvidersParams, signal?: AbortSignal) => {
  return api<GetProvidersResponse>({ url: `/api/providers`, method: 'GET', params, signal });
};

export const getGetProvidersQueryKey = (params?: GetProvidersParams) => {
  return [`/api/providers`, ...(params ? [params] : [])] as const;
};

export const getGetProvidersQueryOptions = <
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = GetProvidersErrorResponse,
>(
  params?: GetProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProvidersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProviders>>> = ({ signal }) =>
    getProviders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProviders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getProviders>>>;
export type GetProvidersQueryError = GetProvidersErrorResponse;

export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = GetProvidersErrorResponse,
>(
  params: undefined | GetProvidersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = GetProvidersErrorResponse,
>(
  params?: GetProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProviders>>,
          TError,
          Awaited<ReturnType<typeof getProviders>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = GetProvidersErrorResponse,
>(
  params?: GetProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetProviders<
  TData = Awaited<ReturnType<typeof getProviders>>,
  TError = GetProvidersErrorResponse,
>(
  params?: GetProvidersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getProviders>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetProvidersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
